import { useContext } from 'react';
import { LicenseContext } from 'contexts/LicenseContext';

export const useLicense = () => {
  const context = useContext(LicenseContext);
  if (!context) throw new Error('License context must be used inside a LicenseProvider');
  return context;
};
